export default __webpack_public_path__ + "static/media/SriTrangLogo.03e50082.png";